import { b as E, e as S, g as M, h as O, i as T, j, o as B } from "./keys-CQjWNUL0.mjs";
import { r as C, a as N, b as U, c as L } from "./correct-is-regexp-logic-DUuS52mu.mjs";
var $ = {}, p;
function w() {
  if (p) return $;
  p = 1;
  var r = E(), t = S.includes, s = M, u = C(), n = s(function() {
    return !Array(1).includes();
  });
  return r({ target: "Array", proto: !0, forced: n }, {
    includes: function(i) {
      return t(this, i, arguments.length > 1 ? arguments[1] : void 0);
    }
  }), u("includes"), $;
}
var a, q;
function K() {
  if (q) return a;
  q = 1, w();
  var r = O;
  return a = r("Array", "includes"), a;
}
var I = {}, h;
function k() {
  if (h) return I;
  h = 1;
  var r = E(), t = T, s = N(), u = j, n = U(), e = L(), i = t("".indexOf);
  return r({ target: "String", proto: !0, forced: !e("includes") }, {
    includes: function(P) {
      return !!~i(
        n(u(this)),
        n(s(P)),
        arguments.length > 1 ? arguments[1] : void 0
      );
    }
  }), I;
}
var c, y;
function z() {
  if (y) return c;
  y = 1, k();
  var r = O;
  return c = r("String", "includes"), c;
}
var d, R;
function D() {
  if (R) return d;
  R = 1;
  var r = B, t = K(), s = z(), u = Array.prototype, n = String.prototype;
  return d = function(e) {
    var i = e.includes;
    return e === u || r(u, e) && i === u.includes ? t : typeof e == "string" || e === n || r(n, e) && i === n.includes ? s : i;
  }, d;
}
var o, _;
function F() {
  if (_) return o;
  _ = 1;
  var r = D();
  return o = r, o;
}
var l, b;
function G() {
  if (b) return l;
  b = 1;
  var r = F();
  return l = r, l;
}
var v, A;
function H() {
  if (A) return v;
  A = 1;
  var r = G();
  return v = r, v;
}
var f, m;
function J() {
  return m || (m = 1, f = H()), f;
}
var g, x;
function X() {
  return x || (x = 1, g = J()), g;
}
export {
  X as r
};
//# sourceMappingURL=includes-sHzLfkB4.mjs.map
